import { Link } from 'react-router-dom';
import { LockIcon, RotateCcwIcon, PackageIcon } from 'lucide-react';
import { founder } from '../../data/content';
import { policyCopy } from '../../data/policies';
import { legalLinks } from '../../data/legal';
import { shopLabels } from '../../data/shopLabels';
const legalLinkCls = 'underline underline-offset-2 transition-colors duration-150 ease-soft hover:text-ink';

/**
 * Wat je gerust stelt op het moment dat je betaalt: direct onder de knop, niet verstopt
 * in de footer. Drie korte feiten, daarna de kleine lettertjes.
 */
export function CheckoutTrust() {
  const promises = [{
    icon: LockIcon,
    text: 'Veilig betalen via een beveiligde verbinding'
  }, {
    icon: RotateCcwIcon,
    text: policyCopy.returns
  }, {
    icon: PackageIcon,
    text: `Door ${founder.firstName} zelf ingepakt, met gebruiksadvies`
  }];
  return <div className="mt-5" data-id="element-7035" data-mp="3bpcmwz2zbybc">
      <ul className="grid gap-2.5 border-y border-line py-4 sm:grid-cols-3 sm:gap-4" data-id="element-7036" data-mp="3gmmbydmgi7yn">
        {promises.map(({
        icon: Icon,
        text
      }) => <li key={text} className="flex items-start gap-2 text-[13px] leading-snug text-muted" data-id="element-7037" data-mp="3vyy6vonn8knt">
            <Icon className="mt-0.5 h-4 w-4 shrink-0 text-clay" strokeWidth={1.5} aria-hidden="true" data-id="element-7038" data-mp="3qxsdrpq2mvdr" />
            {text}
          </li>)}
      </ul>
      <p className="mt-4 text-center text-[12px] leading-relaxed text-muted" data-id="element-7039" data-mp="3hy5b70llvjj4">
        Ongeopende producten: 14 dagen{' '}
        <Link to={legalLinks.shipping} target="_blank" rel="noreferrer" className={legalLinkCls} data-id="element-7040" data-mp="ijjqmx6biwsz">
          wettelijke bedenktijd<span className="sr-only" data-id="element-7041" data-mp="dkysr4ejgp7p"> {shopLabels.newTab}</span>
        </Link>
        . Door te bestellen ga je akkoord met de{' '}
        <Link to={legalLinks.terms} target="_blank" rel="noreferrer" className={legalLinkCls} data-id="element-7042" data-mp="8re4i42qz9lp">
          algemene voorwaarden<span className="sr-only" data-id="element-7043" data-mp="4pss0ju4kxc1"> {shopLabels.newTab}</span>
        </Link>{' '}
        en het{' '}
        <Link to={legalLinks.privacy} target="_blank" rel="noreferrer" className={legalLinkCls} data-id="element-7044" data-mp="11bcob4wc1671">
          privacybeleid<span className="sr-only" data-id="element-7045" data-mp="2qqndx9ila10d"> {shopLabels.newTab}</span>
        </Link>
        .
      </p>
    </div>;
}